<template>

    <div id="tenants">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Tenants</h1>
            </div>

            <div class="flex mb-4 justify-end">
                <router-link :to="{ name: 'tenants.create' }" custom v-slot="{ navigate }">
                    <button @click="navigate" class="btn">
                        Create Tenant
                    </button>
                </router-link>
            </div>
        </div>

        <div class="flex flex-col"  v-if="loaded">

            <div class="index-table" v-if="form.tenantsAvailable()">
                <div>
                    <div>
                        <table>
                            <thead>
                            <tr>
                                <th scope="col" class="text-left tracking-wider">
                                    Tenant Name
                                </th>
                                <th scope="col" class="text-center tracking-wider">
                                    status
                                </th>
                                <th scope="col" class="hidden lg:table-cell text-right tracking-wider">
                                    Created
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="colored-row" v-for="(tenant, index) in form.tenants.data" @click.prevent="">
                                <td>
                                    <span class="font-medium text-gray-700">{{ tenant.name }}</span><br>
                                    <span class="text-xs text-gray-400">{{ tenant.prefix }}</span>
                                </td>
                                <td class="text-center">
                                    <span class="status-box status-complete" v-if="tenant.active">
                                        Active
                                    </span>
                                    <span class="status-box status-cancelled" v-else>
                                        Inactive
                                    </span>
                                </td>
                                <td class="hidden lg:table-cell text-right">
                                    {{ formatDate(tenant.created_at) }}<br>
                                    <span class="text-xs text-gray-400">Last Updated {{ formatDate(tenant.updated_at) }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div class="panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Tenants Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any tenants.
                    </p>
                </div>
            </div>

        </div>
        <Loading message="Loading Tenants" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {Tenant} from "../../app/Tenant/Tenant";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "Tenants",
    mixins: [PermissionMixin, FormattingMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new Tenant();

            vm.form.index().then(response => {
                resolve(true);
            }).catch(error => vm.handleError(error));

        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


